import { render, staticRenderFns } from "./FilmMakerProfile.vue?vue&type=template&id=2fa618da&scoped=true&"
import script from "./FilmMakerProfile.vue?vue&type=script&lang=js&"
export * from "./FilmMakerProfile.vue?vue&type=script&lang=js&"
import style0 from "./FilmMakerProfile.vue?vue&type=style&index=0&id=2fa618da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa618da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VLayout})
